package pl.mothdigital.neuronowi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPolicyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("PrivacyPolicy.md", FrontMatterElement.EmptyMap))
}

@Page("/privacy-policy")
@Composable
fun PrivacyPolicyPage() {
    pl.mothdigital.neuronowi.components.layouts.MarkdownLayout("Polityka prywatności", "Zasady ochrony danych") {
        org.jetbrains.compose.web.dom.H1(attrs = { id("polityka-prywatności") }) {
            org.jetbrains.compose.web.dom.Text("Polityka Prywatności")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Ostatnia aktualizacja: 9 maja 2025 r.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("1-informacje-ogólne") }) {
            org.jetbrains.compose.web.dom.Text("1. Informacje ogólne")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych użytkowników strony internetowej ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("neuronowi.pl")
            }
            org.jetbrains.compose.web.dom.Text(", prowadzonej przez:")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Centrum Terapii NeuroNowi")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Fabryczna 17a/01, 65-410 Zielona Góra")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📧 ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📞 +48 500 124 500 | +48 600 234 002")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Strona ma charakter informacyjny i nie zbiera danych osobowych w sposób aktywny.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("2-zakres-i-cel-przetwarzania-danych") }) {
            org.jetbrains.compose.web.dom.Text("2. Zakres i cel przetwarzania danych")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Nie zbieramy danych osobowych za pośrednictwem formularzy kontaktowych, rejestracji użytkownika, newsletterów ani narzędzi analitycznych. Dane użytkowników mogą zostać przekazane wyłącznie w przypadku kontaktu e-mailowego lub telefonicznego z naszą placówką.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("3-podstawa-prawna-przetwarzania") }) {
            org.jetbrains.compose.web.dom.Text("3. Podstawa prawna przetwarzania")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("W przypadku, gdy użytkownik zdecyduje się na kontakt z administratorem danych (np. za pośrednictwem poczty e-mail), przetwarzanie jego danych odbywa się na podstawie:")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("art. 6 ust. 1 lit. b RODO – tj. niezbędność do podjęcia działań na żądanie osoby, której dane dotyczą,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("lub art. 6 ust. 1 lit. f RODO – tj. uzasadnionego interesu administratora.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("4-odbiorcy-danych") }) {
            org.jetbrains.compose.web.dom.Text("4. Odbiorcy danych")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Dane osobowe nie są przekazywane podmiotom trzecim, za wyjątkiem sytuacji wymaganych przepisami prawa.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("5-przekazywanie-danych-poza-eog") }) {
            org.jetbrains.compose.web.dom.Text("5. Przekazywanie danych poza EOG")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Administrator nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy (EOG).")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("6-okres-przechowywania-danych") }) {
            org.jetbrains.compose.web.dom.Text("6. Okres przechowywania danych")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Dane przekazane dobrowolnie przez użytkownika (np. przez e-mail) są przechowywane przez okres niezbędny do realizacji celu kontaktu oraz zgodnie z wymaganiami prawa.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("7-prawa-użytkownika") }) {
            org.jetbrains.compose.web.dom.Text("7. Prawa użytkownika")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Każda osoba, której dane dotyczą, ma prawo do:")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("dostępu do danych,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("sprostowania danych,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("usunięcia danych,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("ograniczenia przetwarzania,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("przenoszenia danych,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("wniesienia sprzeciwu wobec przetwarzania,")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Kontakt w sprawie realizacji praw: ")
            org.jetbrains.compose.web.dom.B {
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                    org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
                }
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("8-pliki-cookies") }) {
            org.jetbrains.compose.web.dom.Text("8. Pliki cookies")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Strona ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("nie korzysta")
            }
            org.jetbrains.compose.web.dom.Text(" z plików cookies ani żadnych technologii śledzących.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("9-środki-bezpieczeństwa") }) {
            org.jetbrains.compose.web.dom.Text("9. Środki bezpieczeństwa")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Administrator dokłada wszelkich starań, aby zapewnić odpowiedni poziom bezpieczeństwa danych, m.in. poprzez stosowanie środków technicznych oraz organizacyjnych chroniących przed nieuprawnionym dostępem.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("10-hosting") }) {
            org.jetbrains.compose.web.dom.Text("10. Hosting")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Strona jest hostowana na serwerze zlokalizowanym we Francji, dostarczanym przez firmę ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("OVH SAS")
            }
            org.jetbrains.compose.web.dom.Text(" – dostawcę usług hostingowych spełniającego wymogi RODO i zobowiązanego do zapewnienia odpowiednich zabezpieczeń danych osobowych.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("11-zmiany-w-polityce-prywatności") }) {
            org.jetbrains.compose.web.dom.Text("11. Zmiany w Polityce Prywatności")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej polityce. Aktualna wersja polityki będzie zawsze dostępna na stronie ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("neuronowi.pl")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
        com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("W razie jakichkolwiek pytań dotyczących polityki prywatności, prosimy o kontakt pod adresem: ")
            org.jetbrains.compose.web.dom.B {
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                    org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
                }
            }
        }
    }
}
